import { useContext, useEffect, useState } from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Card from "../../../../components/cards/Card";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import { Header, StyledDialog } from "../styles/GerenciamentoContrato";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import useGerenciamentoContratoController from "../controllers/GerenciamentoContratoController";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import SelectErp from "../../../../components/basics/SelectErp";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { useHistory } from "react-router";

const ModalCancelamentoContrato = ({
  open,
  setOpen,
  contractId,
  setItensTable = () => {},
}) => {
  const {
    reasonForCancellation,
    setReasonForCancellation,
    cancelFrom,
    setCancelFrom,
    setListCancelFrom,
    listCancelFrom,
  } = useContext(GerenciamentoContratoContext);

  const { queryParams } = useContext(QueryParamsContext);
  const { push } = useHistory();
  const { setLoading } = useContext(GerenciamentoContratoContext);

  const { handleSelectReasonForCancellatio, cancelContract, getContasReceber } =
    useGerenciamentoContratoController();

  const [modalReasonForCancellatioOpen, setModalReasonForCancellatioOpen] =
    useState(false);

  const columnsTypeServiceModal = [
    { label: "Descrição", id: "descricao" },
    { label: "Ativo", id: "liberado" },
  ];

  const [errorInput, setErrorInput] = useState({});
  const [loadingList, setLoadingList] = useState(false);

  // sempre que abrir o modal, reseta a lista de contas a receber
  useEffect(() => {
    setListCancelFrom([]);
    setCancelFrom(null);
  }, [setListCancelFrom, setCancelFrom]);

  useEffect(() => {
    if (!contractId || !queryParams?.empresa_cnpj) return;

    getContasReceber(contractId, setLoadingList, setListCancelFrom);
  }, [
    contractId,
    queryParams?.empresa_cnpj,
    getContasReceber,
    setListCancelFrom,
  ]);

  const handleCancel = async () => {
    const validateSubmit = validNotNull([
      { key: "reasonForCancellation", value: reasonForCancellation },
      { key: "cancelFrom", value: cancelFrom },
    ]);

    setErrorInput({ ...validateSubmit?.errorsValidation });

    if (validateSubmit?.error)
      return notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );

    try {
      setLoading(true);
      const callback = await cancelContract(contractId);

      if (!callback.success)
        return notify(
          "Ocorreu um erro ao realizar o cancelamento do contrato."
        );

      setItensTable((current) =>
        current.map((el) => {
          if (el.id === contractId) {
            return {
              ...el,
              status: "C",
              rowError: true,
            };
          } else return { ...el };
        })
      );

      handleClose();
      push("listagem?gfAccessToken=" + queryParams.gfAccessToken);
      return notify("Contrato cancelado com sucesso!", true, "success");
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setListCancelFrom([]);
    setReasonForCancellation(null);
    setOpen(false);
  };

  return (
    <>
      {modalReasonForCancellatioOpen && (
        <SearchDialog
          open={modalReasonForCancellatioOpen}
          setOpen={setModalReasonForCancellatioOpen}
          columns={columnsTypeServiceModal}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectReasonForCancellatio}
          route={`faturamento/motivoscancelamentos/v1/getporempresa/${queryParams.empresa_id}`}
          title="MOTIVO DE CANCELAMENTO"
          where={{ liberado: "S", tipo_status: "C" }}
        />
      )}
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-cancelamento-contrato"
      >
        <StyledDialog>
          <DialogTitle id="dialog-title">
            <Header>
              <Grid container align="center" justifyContent="center">
                <Chip
                  bgcolor="tertiary"
                  textcolor="white"
                  label="CANCELAR CONTRATO"
                />
              </Grid>
            </Header>
          </DialogTitle>
          <DialogContent>
            <Card chipcolor="transparent">
              <Grid container spacing={2}>
                <Grid item xs>
                  <SearchSelect
                    descriptionField="descricao"
                    label="Motivo de cancelamento"
                    value={reasonForCancellation}
                    setValue={setReasonForCancellation}
                    route={`faturamento/motivoscancelamentos/v1/getporempresa/${queryParams.empresa_id}`}
                    filter="descricao"
                    variant="filled"
                    error={!!errorInput?.reasonForCancellation}
                    where={{ liberado: "S", tipo_status: "C" }}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Btn
                    label={<SearchIcon />}
                    full="true"
                    onClick={() => setModalReasonForCancellatioOpen(true)}
                    bgcolor="tertiary"
                  />
                </Grid>
                <Grid item xs>
                  <SelectErp
                    label="CANCELAR VENCIMENTO A PARTIR DE: "
                    value={cancelFrom}
                    setValue={setCancelFrom}
                    optionsList={listCancelFrom}
                    descriptionField="value"
                    error={!!errorInput?.cancelFrom}
                    loading={loadingList}
                  />
                </Grid>
              </Grid>
            </Card>
          </DialogContent>
          <DialogActions>
            <Btn onClick={handleClose} bgcolor="darkred" label="Cancelar" />
            <Btn
              onClick={handleCancel}
              bgcolor="primary"
              label="Realizar Cancelamento"
            />
          </DialogActions>
        </StyledDialog>
      </Dialog>
    </>
  );
};

export { ModalCancelamentoContrato };
